import PropTypes from 'prop-types'
import useCMSRequest from './hooks/useCMSRequest'

CMSEntryById.propTypes = {
  children: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired
}

export default function CMSEntryById({ children, id }) {
  const response = useCMSRequest(`/entries/${id}`, { select: 'fields,sys.id' })

  if (response) {
    const props = { ...response.fields, id: response.sys.id }
    return children(props)
  }

  return null
}
